import { ButtonColor } from "@/common/enum/button-color";
import { Button, Modal, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { Address } from "react-daum-postcode";
import { useRecoilState, useSetRecoilState } from "recoil";
import { toastState } from "../../atoms/system/toast-state";
import { profileState } from "../../atoms/user/profile-state";
import { userService } from "../../services/user-service";
import { UpdatePartnerPayload } from "../../types/payload/update-partner-payload";
import { AddressSearchButton } from "../button/AddressSearchButton";
import { CustomHelperText } from "../CustomHelperText";
import { TextInputLabel } from "../label/TextInputLabel";
import { H4 } from "../typography/H4";

interface Props {
  closeModal: () => void;
}

const initInputs = {
  postalCode: "",
  jibun: "",
  road: "",
  detail: "",
};
export const PartnerAddressModal: React.FC<Props> = ({ closeModal }) => {
  const [inputs, setInputs] = useState(initInputs);

  const [profile, setProfile] = useRecoilState(profileState);
  const setToast = useSetRecoilState(toastState);

  const [aggregateErrors, setAggregateErrors] = useState({
    postalCode: "",
    road: "",
    jibun: "",
    detailAddress: "",
  });

  const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    console.log(inputs);
    const payload: UpdatePartnerPayload = {
      postalCode: inputs.postalCode,
      road: inputs.road,
      jibun: inputs.jibun,
      detailAddress: inputs.detail,
      // oldAddress: inputs.oldAddress,
      // newAddress: inputs.newAddress,
    };

    const updatePartnerResponse = await userService.updatePartnerAsync(
      profile.id,
      payload
    );

    setAggregateErrors({
      postalCode: updatePartnerResponse.data.aggregateErrors?.postalCode || "",
      road: updatePartnerResponse.data.aggregateErrors?.road || "",
      jibun: updatePartnerResponse.data.aggregateErrors?.jibun || "",
      detailAddress:
        updatePartnerResponse.data.aggregateErrors?.detailAddress || "",
    });

    if (updatePartnerResponse.ok) {
      const getMeResponse = await userService.getMe();
      if (!getMeResponse.ok) {
        return;
      }
      setProfile(getMeResponse.data);
      setToast({
        show: true,
        messages: [`주소지를 수정했습니다.`],
      });
      closeModal();
    }
  };

  const setAddress = (address: Address) => {
    setInputs({
      postalCode: address.zonecode,
      road: address.roadAddress,
      jibun: address.jibunAddress,
      detail: "",
    });
  };

  useEffect(() => {
    setInputs(initInputs);
  }, []);

  const disabled = false;
  // !inputs.newAddress ||
  // !initInputs.oldAddress ||
  // !initInputs.newAddressConfirm ||
  // inputs.newAddress !== inputs.newAddressConfirm;

  return (
    <Modal size="2xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>주소지 수정</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex justify-center">
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col">
              <TextInputLabel required>주소지</TextInputLabel>
              <div className="flex flex-col items-center gap-[8px]">
                <div className="flex w-[572px]">
                  <TextInput
                    required
                    className="mr-[10px] w-[325px]"
                    placeholder="우편번호"
                    name="postalCode"
                    value={inputs.postalCode}
                    onChange={handleTextInputChange}
                    disabled
                  />
                  <AddressSearchButton setAddress={setAddress} />
                </div>
                <TextInput
                  className="w-[572px]"
                  placeholder="기본주소"
                  name="road"
                  value={inputs.road}
                  onChange={handleTextInputChange}
                  disabled
                />
                <TextInput
                  className="w-[572px]"
                  placeholder="나머지 주소 입력 자유"
                  name="detail"
                  value={inputs.detail}
                  onChange={handleTextInputChange}
                />
              </div>
              <CustomHelperText
                isError={Object.values(aggregateErrors).some(
                  (error) => !!error
                )}
                text={
                  Object.values(aggregateErrors).find((error) => !!error) ||
                  "해당 주소지는 기본 배송지로 사용됩니다."
                }
              />
            </div>
            <Button
              disabled={disabled}
              color={disabled ? ButtonColor.DISABLED : ButtonColor.PRIMARY}
              onClick={handleSubmit}
              className="w-full"
              size={"xl"}
            >
              수정하기
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
